document.addEventListener('DOMContentLoaded', function() {
  var colors = document.querySelectorAll('.pd-color');
  colors.forEach(function(btn) {
    btn.addEventListener('click', function() {
      colors.forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var name = btn.getAttribute('data-name');
      var img = btn.getAttribute('data-img');
      var nameEl = document.getElementById('pd-color-name');
      var imgEl = document.getElementById('pd-main-img');
      if (nameEl) nameEl.textContent = name;
      if (imgEl) { imgEl.src = img; imgEl.alt = 'Cloud Slides - ' + name; }
    });
  });
});
// ── STICKY BANNER ──
(function() {
  var banner = document.querySelector('.sticky-banner');
  var closeBtn = document.querySelector('.sticky-banner-close');
  if (!banner) return;

  var threshold = window.innerHeight;
  var closed = false;

  window.addEventListener('scroll', function() {
    var scrollY = window.scrollY;

    // если вернулся в топ — сбрасываем closed
    if (scrollY < 50) {
      closed = false;
    }

    if (!closed && scrollY > threshold) {
      banner.classList.add('visible');
    } else {
      banner.classList.remove('visible');
    }
  }, { passive: true });

  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      closed = true;
      banner.classList.remove('visible');
    });
  }
})();
// ── FAQ ACCORDION ──
(function() {
  var questions = document.querySelectorAll('.adv2-faq-q');
  questions.forEach(function(q) {
    q.addEventListener('click', function() {
      var answer = q.nextElementSibling;
      var isOpen = q.classList.contains('open');
      // закрыть все
      questions.forEach(function(otherQ) {
        otherQ.classList.remove('open');
        if (otherQ.nextElementSibling) {
          otherQ.nextElementSibling.classList.remove('open');
        }
      });
      // открыть текущий если был закрыт
      if (!isOpen) {
        q.classList.add('open');
        if (answer) answer.classList.add('open');
      }
    });
  });
})();